<template>
  <form-builder-editor-field
    :item="item"
    :show-required="true"
    :show-hide-in-form="true"
    :show-hide-in-reports="true"
    :show-hide-in-preview="true"
    :show-share-with-participant="true"
    :show-is-shared="true"
    v-on="$listeners"
  >
    <div class="form-group" >
      <label class="active" :for="item.name + '-maxsize'">
        Maximum number of characters
      </label>
      <input :id="item.name + '-maxsize'" class="form-control" type="number"
             min="0"
             v-model.number="item.maxSize"
             :disabled="!!item.minSize"
             oninput="validity.valid||(value='');">
    </div>

    <div class="form-group">
      <label class="active" :for="item.name + '-maxsize'">
        Required number of characters
      </label>
      <input :id="item.name + '-minsize'" class="form-control" type="number"
             min="0"
             v-model.number="item.minSize"
             :disabled="!!item.maxSize"
             oninput="validity.valid||(value='');">
    </div>
    <div class="form-group">
      <label class="active" :for="item.name + '-decimalsize'">Decimal size</label>

      <input :id="item.name + '-decimalsize'" class="form-control" type="number"
             min="0"
             v-model.number="item.decimalSize"
             oninput="validity.valid||(value='');">
    </div>
  </form-builder-editor-field>
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>




// WEBPACK FOOTER //
// FormBuilderEditorNumber.vue?0d491013